import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react";
import axios from "axios";
import VerComentarios from "views/examples/VerComentarios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import CargaAnexo from "./CargarAnexos";

const ComentariosVisualizacion = ({ id }) => {
  const cookie = new Cookies();
  const [comentario, setComentario] = useState("");
  const [loading, setLoading] = useState(false);

  const mostrarAlerta = (icon, title, text) => {
    Swal.fire({
      icon,
      title,
      text,
      timer: icon === "success" ? 2000 : undefined,
      showConfirmButton: icon !== "success",
      willOpen: () => {
        setTimeout(() => {
          const container = document.querySelector(".swal2-container");
          const popup = document.querySelector(".swal2-popup");
          if (container) container.style.zIndex = "9999";
          if (popup) popup.style.zIndex = "10000";
        }, 50);
      },
    });
  };

  const obtenerFechaBogota = () => {
    const fecha = new Date();
    const fechaFormateada = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(fecha);
    return fechaFormateada.replace(" ", "T");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      solicitudId: JSON.stringify(id),
      comentarios: comentario,
      usuarioId: cookie.get("id"),
      fechaCreacion: obtenerFechaBogota(),
    };

    try {
      await axios.post(
        "https://contratosback-dev.azurewebsites.net/api/v1/CreaComentarios",
        data,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        }
      );

      mostrarAlerta(
        "success",
        "¡Comentario creado!",
        "Se ha guardado el comentario correctamente."
      );
      setComentario("");
    } catch (error) {
      console.error(error);
      mostrarAlerta("error", "Error al crear", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <h3 className="mb-0">Agregar Comentario</h3>
              </CardHeader>
              <CardBody>
                {/* Formulario de comentario */}
                <Form onSubmit={handleSubmit}>
                  <h6 className="heading-small text-muted mb-4">Comentarios</h6>

                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder="Escriba aquí su comentario"
                      value={comentario}
                      onChange={(e) => setComentario(e.target.value)}
                      required
                    />
                  </FormGroup>

                  <Button
                    color="primary"
                    size="lg"
                    type="submit"
                    disabled={loading || comentario.trim() === ""}
                    style={{ padding: "5px 5px", fontSize: "10px" }}
                  >
                    {loading ? "Guardando..." : "Guardar Comentario"}
                  </Button>
                </Form>

                {/* Carga de anexos, fuera del formulario pero alineado a la derecha */}
                <div className="text-left mt-3">
                  <CargaAnexo id={id} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Visualización de comentarios existentes con scroll */}
      {cookie.get("tipo_Usuario") && (
        <div
          style={{
            maxHeight: "400px", // ajusta la altura si es necesario
            overflowY: "auto",
            padding: "10px",
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "8px",
          }}
        >
          <VerComentarios id={id} />
        </div>
      )}
    </>
  );
};

export default ComentariosVisualizacion;
